import * as fileTypes from "components/Shared/MDropzone/utility/fileTypes";
import ExcelCustomValidationFunctions from "components/Shared/MDropzone/utility/fileTypeToCustomValidationFunctionsDictionary/ExcelCustomValidationFunctions";

export default ({
  [fileTypes.EXCEL]: ExcelCustomValidationFunctions,
});